module.exports = __webpack_public_path__ + "static/media/RescueAtLakeWildBookCover.cb4cc8d9.jpg";